import React, { useEffect } from 'react';
import { QueryClientProvider, QueryClient } from 'react-query';
import { Route, Switch, useLocation } from 'react-router-dom';
import ObjectPage from 'components/pages/collection/ObjectPage';
import { SiteProvider } from 'site/SiteContext';
import { RedirectRoutes } from 'helpers/DynamicRedirects';
import PageFooter from 'components/organisms/nav/PageFooter';
import MenuHeader from 'components/organisms/nav/MenuHeader';
import SiteAlert from 'components/organisms/SiteAlert';
import ScrollToTop from 'helpers/scrolltotop';
import SearchProvider from 'helpers/search';
import ReactGA from 'react-ga4';

const queryClient = new QueryClient({
 defaultOptions: {
   queries: {
     refetchOnWindowFocus: false,
   },
 },
});

ReactGA.initialize(process.env.REACT_APP_GA4_TRACKING_ID);

const App = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location.pathname]);

  return (
    <QueryClientProvider client={queryClient}>
        <SiteProvider>
            <SearchProvider>
                <SiteAlert />
                <MenuHeader />
                <ScrollToTop>
                    <Switch>
                        <Route exact path="/art/collection/object/:objectID" component={ObjectPage} />;
                        <RedirectRoutes />
                    </Switch>
                </ScrollToTop>
                <PageFooter />
            </SearchProvider>
        </SiteProvider>
    </QueryClientProvider>
  );
};

export default App;
